import { xGetFromToIndex } from 'ml-spectra-processing';
/**
 * Filter that allows to
 * @param data
 * @param options
 */
export function fromTo(data, options = {}) {
    const { fromIndex, toIndex } = xGetFromToIndex(data.x, options);
    return {
        data: {
            x: data.x.subarray(fromIndex, toIndex + 1),
            y: data.y.subarray(fromIndex, toIndex + 1),
        },
    };
}
//# sourceMappingURL=fromTo.js.map